export default __webpack_public_path__ + "static/media/IconDesc_Wreath.64.2d6d1d4b.png";